import { render, staticRenderFns } from "./RealEstateDeletedIndicator.vue?vue&type=template&id=4d3d84fd&"
import script from "./RealEstateDeletedIndicator.vue?vue&type=script&lang=js&"
export * from "./RealEstateDeletedIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports